import { ComponentPropsWithoutRef } from 'react';
import { PaginationProps } from '~/types';
import { StyledList, StyledListItem, StyledNav, StyledPaginationButton } from './styles';
import { ChevronLeftIcon, ChevronRightIcon } from '@slal/ui/icons';

export const Pagination = ({
    next,
    previous,
    setPage,
    ...otherProps
}: ComponentPropsWithoutRef<'nav'> & PaginationProps) => {
    const previousButtonTitle = previous ? 'Previous page' : 'No previous page available';
    const nextButtonTitle = next ? 'Next page' : 'No next page available';

    return (
        <StyledNav {...otherProps}>
            <StyledList>
                <StyledListItem>
                    <StyledPaginationButton
                        aria-label={previousButtonTitle}
                        onClick={() => previous && setPage(previous)}
                        tabIndex={0}
                        title={previousButtonTitle}
                    >
                        <ChevronLeftIcon />
                    </StyledPaginationButton>
                </StyledListItem>

                <StyledListItem>
                    <StyledPaginationButton
                        aria-label={nextButtonTitle}
                        onClick={() => next && setPage(next)}
                        tabIndex={0}
                        title={nextButtonTitle}
                    >
                        <ChevronRightIcon />
                    </StyledPaginationButton>
                </StyledListItem>
            </StyledList>
        </StyledNav>
    );
};
